import { useEffect } from 'react';

// ----------------------------------------------------------------------

/**
 * 전역 보안 보호 훅
 *
 * 앱 전체에 적용되는 기본 보안 정책을 관리합니다.
 * - 전역 우클릭 방지
 * - 키보드 단축키 방지 (Ctrl+S, Ctrl+P)
 *
 * @example
 * ```tsx
 * // 앱 최상위에서 사용
 * const App = () => {
 *   useGlobalSecurity();
 *   return <div>...</div>;
 * };
 * ```
 */
export const useGlobalSecurity = () => {
  useEffect(() => {
    // 전역 우클릭 방지
    const handleContextMenu = (event: MouseEvent) => {
      console.log('전역 우클릭 방지');
      event.preventDefault();
    };

    // 키보드 단축키 방지
    const handleKeyDown = (event: KeyboardEvent) => {
      // 저장 단축키 방지 (Ctrl+S, Cmd+S)
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 's') {
        event.preventDefault();
        console.log('저장 기능 차단');
      }

      // 인쇄 단축키 방지 (Ctrl+P, Cmd+P)
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'p') {
        event.preventDefault();
        console.log('인쇄 기능 차단');
      }
    };

    // 이벤트 리스너 등록
    window.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);

    // 정리 함수
    return () => {
      window.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
};
